import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {InitPreferenceStep1Page} from "../init-preference-step1/init-preference-step1";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {ApiAuthProvider} from "../../providers/api-auth/api-auth";
import {IntroWelcomePage} from "../intro-welcome/intro-welcome";
import {LoginPage} from "../login/login";
import {IntroNamePage} from "../intro-name/intro-name";

/**
 * Generated class for the InitHelloPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-init-hello',
  templateUrl: 'init-hello.html',
})
export class InitHelloPage {
  nextHref: any = InitPreferenceStep1Page;
  isStarted: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public state: UserStateProvider, public apiAuth: ApiAuthProvider) {
    console.log(this.state.user);

    this.isStarted = (this.state.user.started == true)
  }

  ionViewWillLoad() {
    if(!this.state.user.firstName) {
      this.navCtrl.push(IntroNamePage);
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InitHelloPage');
  }

  prevPage() {
    this.apiAuth.logout().then(() => {
      this.navCtrl.push(LoginPage).then(() => {
        this.navCtrl.remove(this.navCtrl.getPrevious().index)
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/init-hello/init-hello.ts